import * as api from "services/api";
import { getErrors } from "helpers/error";

export const GET_COMPANY_OBLIGATION =
	"[COMPANY OBLIGATION DETAIL] GET_COMPANY_OBLIGATION";
export const GET_COMPANY_OBLIGATION_ERROR =
	"[COMPANY OBLIGATION DETAIL] GET_COMPANY_OBLIGATION_ERROR";
export const GET_COMPANY_OBLIGATION_SUCCESS =
	"[COMPANY OBLIGATION DETAIL] GET_COMPANY_OBLIGATION_SUCCESS";

export const DELETE_OBLIGATION = "[OBLIGATION DETAIL] DELETE_OBLIGATION";
export const DELETE_OBLIGATION_ERROR =
	"[OBLIGATION DETAIL] DELETE_OBLIGATION_ERROR";
export const DELETE_OBLIGATION_SUCCESS =
	"[OBLIGATION DETAIL] DELETE_OBLIGATION_SUCCESS";

export const SET_VALUE = "[COMPANY OBLIGATION DETAIL] SET_VALUE";
export const CLEAR_VALUES = "[COMPANY OBLIGATION DETAIL] CLEAR_VALUES";

export function setValue(payload) {
	return dispatch => {
		dispatch({ type: SET_VALUE, payload });
	};
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getObligationById(id, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_COMPANY_OBLIGATION
		});

		try {
			const { login } = getState();

			let response = await api.sendGet(`/obligation/${id}`, {
				Authorization: "Bearer " + login.token
			});

			let result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_COMPANY_OBLIGATION_SUCCESS,
					payload: result.model
				});
				callback && callback(null, result.model);
			} else {
				dispatch({
					type: GET_COMPANY_OBLIGATION_ERROR,
					payload: getErrors(result.errors)
				});
			}
		} catch (error) {
			return dispatch({
				type: GET_COMPANY_OBLIGATION_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function deleteObligation(id, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: DELETE_OBLIGATION
		});

		try {
			const { login } = getState();

			let response = await api.sendDelete(`/obligation/${id}`, {
				Authorization: "Bearer " + login.token
			});

			let result = await response.json();

			if (result.isValid) {
				dispatch({
					type: DELETE_OBLIGATION_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				dispatch({
					type: DELETE_OBLIGATION_ERROR,
					payload: getErrors(result.errors)
				});
			}
		} catch (error) {
			return dispatch({
				type: DELETE_OBLIGATION_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
